import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    
      const token = localStorage.getItem("token");

    if (token) {
          let sec_rec = req.clone({
              headers: req.headers.set("Authorization",
                  "Bearer " + token)
          });

      return next.handle(sec_rec)
      }
    
    return next.handle(req);
  }
}